export default __webpack_public_path__ + "static/media/large.88ecb0cc.jpg";